import { createApiSlice } from "@common";
import { CRUD_DISQUALIFICATION_REASON } from "@routes";

const apiConfig = [
  {
    name: "addDisqualificationReason",
    method: "post",
    url: CRUD_DISQUALIFICATION_REASON,
    stateKey: "message"
  },
  {
    name: "getDisqualificationReason",
    method: "get",
    url: CRUD_DISQUALIFICATION_REASON,
    stateKey: "data"
  },
  {
    name: "updateDisqualificationReason",
    method: "put",
    url: CRUD_DISQUALIFICATION_REASON,
    stateKey: "message"
  },
  {
    name: "deleteDisqualificationReason",
    method: "delete",
    url: CRUD_DISQUALIFICATION_REASON,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: { data: [], additionalData: [] },
  reducers: {
    setAdditionalData: (state, action) => { state.additionalData = action.payload; },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "disqualificationReason",
  apiConfig,
  customReducers);
const disqualificationReasonSlice = slice;

export default disqualificationReasonSlice.reducer;

export const {
  addDisqualificationReason,
  getDisqualificationReason,
  updateDisqualificationReason,
  deleteDisqualificationReason,

} = thunks;
export const { rowSelect } = actions;
